import { useContext } from 'react'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { prepareAudioData } from './helpers'
import { dispatch } from 'store'
import store from 'store'
import { useFileFormatValidator } from 'hooks/useFileFormatValidator'
import { AudioContentContext } from 'containers/SubSidebar/AudioContent/context'
import { useSelector } from 'react-redux'
import { useTimelineContext } from 'context/TimelineContext'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { checkStorageBeforeUpload } from 'store/features/user/utils'
import { calculateTotalFilesSize } from 'utils/media'

const useAudioUpload = () => {
  const { goToMyMusic } = useContext(AudioContentContext)
  const nextAvailableLineIndex = useSelector(
    projectDataSelectors.nextAvailableLineIndex
  )
  const { getCurrentTimeImmediate } = useTimelineContext()
  const { setAlertPopupsData } = useAlertPopupsContext()

  const checkFileFormat = useFileFormatValidator('audio')

  return async (files: File[] | FileList) => {
    const validFiles = checkFileFormat(Array.from(files))

    if (!validFiles.length) {
      return
    }

    // Check if total file size exceeds available storage
    const totalFilesSize = calculateTotalFilesSize(validFiles)

    const { canUpload } = await checkStorageBeforeUpload(
      totalFilesSize,
      dispatch,
      store.getState
    )

    if (!canUpload) {
      setAlertPopupsData({
        fullStoragePopup: {
          isOpen: true
        }
      })
      return
    }

    goToMyMusic()
    const audioFiles = await prepareAudioData(
      validFiles,
      nextAvailableLineIndex,
      getCurrentTimeImmediate()
    )

    dispatch(
      projectDataThunks.addMultiLineAudios({
        value: audioFiles
      })
    )

    const uploadItems = audioFiles.map((audio, index) => {
      return {
        id: audio.id,
        file: validFiles[index]
      }
    })

    dispatch(projectDataThunks.uploadMultilineAudios(uploadItems))
  }
}

export default useAudioUpload
